import React, { Component } from "react";
import {
  Button,
  Container,
  Divider,
  Form,
  Header,
  Icon,
  Image,
  List,
  Loader,
  Menu,
  Modal,
  Segment,
  Table
} from "semantic-ui-react";
import { capitalize, kebabCase, without } from "lodash";
import queryString from "query-string";
import booleanify from "booleanify";
import { sortBy } from "lodash";
import moment from "moment";
import ReactTable from "react-table";

class ReporteAvanzado extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      error: null,
      records: [],
      total: 0,
      fieldOrder: [],
      headers: {
        actividad: false,
        Asociados: false,
        cierreEjercicio: false,
        codigoPostal: false,
        contacto: false,
        cuit: false,
        domicilioPostal: false,
        email: false,
        fechaFundacion: false,
        fechaAsamblea: false,
        matriculaNacional: false,
        matriculaProvincial: false,
        nombre: false,
        nombreDepartamento: false,
        nombreLocalidad: false,
        nombreRubro: false,
        nombreSector: false,
        nroCarpeta: false,
        protocolo: false,
        situacion: false,
        telefono: false
      },
      open: false
    };

    this.BusquedaService = this.props.feathers.service(
      "/api/busqueda-informe-avanzado"
    );
  }

  findCooperativas(search) {
    this.setState({
      loading: true
    });

    const findLastAsamblea = (asambleas = []) => {
      if (asambleas.length === 0) {
        return "";
      }

      let lastAsamblea = asambleas[0];

      asambleas.forEach(asamblea => {
        if (
          moment(asamblea.fechaAsamblea).isAfter(
            moment(lastAsamblea.fechaAsamblea)
          )
        ) {
          lastAsamblea = asamblea;
        }
      });

      return lastAsamblea.fechaAsamblea;
    };

    this.BusquedaService.find({
      query: {
        ...search,
        limit: 99999
      }
    })
      .then(response => {
        this.setState(
          {
            loading: false,
            records: sortBy(response.records, c =>
              parseInt(c.matriculaNacional)
            ).map(record => ({
              ...record,
              fechaAsamblea: findLastAsamblea(record.asambleas),
              asociados: record.asociados.length,
              nombreSector: record.sector ? record.sector.nombre : "",
              nombreRubro: record.sector ? record.sector.rubro.nombre : "",
              nombreLocalidad: record.localidad ? record.localidad.nombre : "",
              nombreDepartamento: record.localidad
                ? record.localidad.departamento.nombre
                : ""
            })),
            total: response.total
          },
          () => {
            this.togglePrompt();
          }
        );
      })
      .catch(error => {
        console.log(error);
        this.setState({
          loading: false,
          error
        });
      });
  }

  componentDidMount() {
    let search = queryString.parse(window.location.search);

    this.findCooperativas(search);
  }

  createInputHandler(name) {
    let { fieldOrder, headers } = this.state;
    let newFieldOrder = fieldOrder.slice();

    return (e, input) => {
      if (!headers[name]) {
        newFieldOrder.push(name);
      } else {
        newFieldOrder = without(newFieldOrder, name);
      }

      this.setState({
        fieldOrder: newFieldOrder,
        headers: {
          ...headers,
          [name]: !headers[name]
        }
      });
    };
  }

  togglePrompt() {
    this.setState({
      open: !this.state.open
    });
  }

  setPromptData(e) {
    this.setState(
      {
        open: false
      },
      () => window.print()
    );
  }

  renderHeaders() {
    let { fieldOrder: headers } = this.state;

    let th = headers.map((header, index) => {
      return (
        <Table.HeaderCell key={index}>
          {capitalize(kebabCase(header).replace(/-/g, " "))}
        </Table.HeaderCell>
      );
    });

    return <Table.Row>{th}</Table.Row>;
  }

  renderCooperativas() {
    let { loading, fieldOrder: headers } = this.state;

    if (loading) {
      return (
        <Table.Row>
          <Table.Cell>Cargando...</Table.Cell>
        </Table.Row>
      );
    } else {
      return this.state.records.map((record, i) => {
        let data = headers.map((header, j) => {
          return <Table.Cell key={j}>{record[header]}</Table.Cell>;
        });

        return <Table.Row key={i}>{data}</Table.Row>;
      });
    }
  }

  render() {
    let {
      loading,
      error,
      records,
      total,
      headers,
      open,
      fieldOrder
    } = this.state;

    let search = queryString.parse(window.location.search);
    let situacion = null;
    let dpto = null;
    let rubro = null;
    let sector = null;

    if (loading) {
      return <Loader active inline="centered" />;
    }

    if (search.situacion && records.length !== 0) {
      situacion = search.situacion;
    }

    if (search.departamento && records.length !== 0) {
      dpto = records[0].localidad.departamento.nombre;
    }

    if (search.rubro && records.length !== 0) {
      rubro = records[0].sector.rubro.nombre;
    }

    if (search.sector && records.length !== 0) {
      sector = records[0].sector.nombre;
    }

    return (
      <Container fluid>
        <Image
          centered
          style={{ maxHeight: 100 }}
          src={require("../../../assets/img/logo_dgc.jpg")}
        />
        <Header
          dividing
          size="tiny"
          style={{ margin: 0 }}
          subheader="Peru 1186 - Corrientes - dircoopctes@gmail.com - Tel. 0379-4431360 / 4476041"
          textAlign="center"
        />
        <Header style={{ margin: 0 }} as="h4" textAlign="center">
          Información no certificada por el Estado Provincial
        </Header>
        <Header as="h3" textAlign="center">
          LISTADO DE COOPERATIVAS ({records.length})
        </Header>
        <List bulleted horizontal>
          {situacion && (
            <List.Item>
              <strong>SITUACION</strong> : {situacion}
            </List.Item>
          )}
          {dpto && (
            <List.Item>
              <strong>DEPARTAMENTO</strong> : {dpto}
            </List.Item>
          )}
          {rubro && (
            <List.Item>
              <strong>RUBRO</strong> : {rubro}
            </List.Item>
          )}
          {sector && (
            <List.Item>
              <strong>SECTOR</strong> : {sector}
            </List.Item>
          )}
        </List>
        <Table celled compact="very" fixed size="small" striped>
          <Table.Header>{this.renderHeaders()}</Table.Header>
          <Table.Body>{this.renderCooperativas()}</Table.Body>
        </Table>
        <Modal dimmer="blurring" size="small" open={open}>
          <Modal.Header>Seleccion de Campos</Modal.Header>
          <Modal.Content>
            <Form onSubmit={this.setPromptData.bind(this)}>
              <Form.Field>
                <label>Sociedad</label>
                <Form.Group inline>
                  <Form.Checkbox
                    value={headers.nombre}
                    onChange={this.createInputHandler("nombre")}
                    label="Nombre"
                    name="nombre"
                    value="Nombre"
                  />
                  <Form.Checkbox
                    value={headers.actividad}
                    onChange={this.createInputHandler("actividad")}
                    label="Actividad"
                    name="actividad"
                    value="Actividad"
                  />
                  <Form.Checkbox
                    value={headers.cuit}
                    onChange={this.createInputHandler("cuit")}
                    label="CUIT"
                    name="cuit"
                    value="CUIT"
                  />
                  <Form.Checkbox
                    value={headers.matriculaNacional}
                    onChange={this.createInputHandler("matriculaNacional")}
                    label="M.N."
                    name="matriculaNacional"
                    value="M.N."
                  />
                  <Form.Checkbox
                    value={headers.matriculaProvincial}
                    onChange={this.createInputHandler("matriculaProvincial")}
                    label="M.P."
                    name="matriculaProvincial"
                    value="M.P."
                  />
                </Form.Group>
              </Form.Field>
              <Form.Field>
                <label>Datos Generales</label>
                <Form.Group inline>
                  <Form.Checkbox
                    value={headers.asociados}
                    onChange={this.createInputHandler("asociados")}
                    label="Asociados"
                    name="Asociados"
                    value="Asociados"
                  />
                  <Form.Checkbox
                    value={headers.nroCarpeta}
                    onChange={this.createInputHandler("nroCarpeta")}
                    label="Nro Carpeta"
                    name="nroCarpeta"
                    value="Carpeta"
                  />
                  <Form.Checkbox
                    value={headers.protocolo}
                    onChange={this.createInputHandler("protocolo")}
                    label="Protocolo"
                    name="protocolo"
                    value="Protocolo"
                  />
                </Form.Group>
              </Form.Field>
              <Form.Field>
                <label>Categorizacion</label>
                <Form.Group inline>
                  <Form.Checkbox
                    value={headers.nombreRubro}
                    onChange={this.createInputHandler("nombreRubro")}
                    label="Rubro"
                    name="nombreRubro"
                    value="Rubro"
                  />
                  <Form.Checkbox
                    value={headers.nombreSector}
                    onChange={this.createInputHandler("nombreSector")}
                    label="Sector"
                    name="nombreSector"
                    value="Sector"
                  />
                  <Form.Checkbox
                    value={headers.situacion}
                    onChange={this.createInputHandler("situacion")}
                    label="Situacion"
                    name="situacion"
                    value="Situacion"
                  />
                </Form.Group>
              </Form.Field>
              <Form.Field>
                <label>Fechas</label>
                <Form.Group inline>
                  <Form.Checkbox
                    value={headers.fechaFundacion}
                    onChange={this.createInputHandler("fechaFundacion")}
                    label="Fundacion"
                    name="fechaFundacion"
                    value="Fundacion"
                  />
                  <Form.Checkbox
                    value={headers.cierreEjercicio}
                    onChange={this.createInputHandler("cierreEjercicio")}
                    label="Cierre Ejercicio"
                    name="cierreEjercicio"
                    value="Cierre"
                  />
                  <Form.Checkbox
                    value={headers.fechaAsamblea}
                    onChange={this.createInputHandler("fechaAsamblea")}
                    label="Fecha Ultima Asamblea"
                    name="fechaAsamblea"
                    value="fechaAsamblea"
                  />
                </Form.Group>
              </Form.Field>
              <Form.Field>
                <label>Ubicacion</label>
                <Form.Group inline>
                  <Form.Checkbox
                    value={headers.nombreDepartamento}
                    onChange={this.createInputHandler("nombreDepartamento")}
                    label="Dpto"
                    name="nombreDepartamento"
                    value="Dto"
                  />
                  <Form.Checkbox
                    value={headers.nombreLocalidad}
                    onChange={this.createInputHandler("nombreLocalidad")}
                    label="Localidad"
                    name="nombreLocalidad"
                    value="Localidad"
                  />
                  <Form.Checkbox
                    value={headers.codigoPostal}
                    onChange={this.createInputHandler("codigoPostal")}
                    label="C.P."
                    name="codigoPostal"
                    value="C.P."
                  />
                  <Form.Checkbox
                    value={headers.domicilioPostal}
                    onChange={this.createInputHandler("domicilioPostal")}
                    label="Domicilio"
                    name="domicilioPostal"
                    value="Domicilio"
                  />
                </Form.Group>
              </Form.Field>
              <Form.Field>
                <label>Contacto</label>
                <Form.Group inline>
                  <Form.Checkbox
                    value={headers.contacto}
                    onChange={this.createInputHandler("contacto")}
                    label="Contacto"
                    name="contacto"
                    value="Contacto"
                  />
                  <Form.Checkbox
                    value={headers.email}
                    onChange={this.createInputHandler("email")}
                    label="Email"
                    name="email"
                    value="Email"
                  />
                  <Form.Checkbox
                    value={headers.telefono}
                    onChange={this.createInputHandler("telefono")}
                    label="Telefono"
                    name="telefono"
                    value="Telefono"
                  />
                </Form.Group>
              </Form.Field>
              <Button negative>Cancelar</Button>
              <Button
                type="submit"
                floated="right"
                onClick={this.setPromptData.bind(this)}
                positive
                icon="checkmark"
                labelPosition="right"
                content="Aceptar"
              />
            </Form>
            <Divider />
            <List bulleted horizontal>
              {fieldOrder.map((h, i) => (
                <List.Item key={i}>
                  {capitalize(kebabCase(h).replace(/-/g, " "))}
                </List.Item>
              ))}
            </List>
          </Modal.Content>
        </Modal>
      </Container>
    );
  }
}

export default ReporteAvanzado;



// WEBPACK FOOTER //
// ./client/components/pages/informes/ReporteAvanzadoView.js